import { render } from "./headbar-icon.vue?vue&type=template&id=3bbc5f68&ts=true"
import script from "./headbar-icon.vue?vue&type=script&lang=ts"
export * from "./headbar-icon.vue?vue&type=script&lang=ts"

import exportComponent from "/home/jenkins/agent/workspace/miyo-prod/ftrc-prd/src/project/fotile-riskctl/code/frontend/mgr/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__